<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormProductoBancoImagen" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <button @click="AbreModal" type="button" class="btn btn-primary"><i class="fa fa-plus"></i> Agregar Producto</button>
                                            </div>
                                        </div>

                                        <div class="table-responsive">
                                            <table class="table align-items-center mb-0">
                                                <thead>
                                                    <tr>
                                                        <th :class="StyleTh">Producto</th>
                                                        <th :class="StyleTh">Precio</th>
                                                        <th :class="StyleTh">Cantidad</th>
                                                        <th :class="StyleTh">Total</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item,index) in ProductosSeleccionados" :key="index">
                                                        <td>
                                                            <input disabled type="text" class="form-control" v-model="item.Nombre">
                                                        </td>
                                                        <td>
                                                            <input disabled type="text" class="form-control" v-model="item.Costo">
                                                        </td>
                                                        <td>
                                                            <input type="text" class="form-control" v-model="item.Cantidad" @input="$onlyNums($event,item,'Cantidad');Calcular(item,index);">
                                                            <CValidation v-if="errorvalidacion[item.IdProducto]" :Mensaje="'*'+errorvalidacion[item.IdProducto].Cantidad[0]"/>
                                                        </td>
                                                        <td>
                                                            <input disabled type="text" class="form-control" v-model="item.PrecioTotal">
                                                        </td>
                                                        <td>
                                                            <button type="button" class="btn btn-link text-danger text-gradient px-3 mb-0" @click="EliminarProducto(item.IdProducto)">
                                                                <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        
                                        <CBtnSave :poBtnSave="oBtnSave" />
                                    
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>

        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSaveModal">
            <template slot="Form">
                <FormModal 
                :poBtnSave="oBtnSaveModal" 
                :objProductosSeleccionados="ProductosSeleccionados"
                :objProductosRegistrados="BancoImagenProductos"></FormModal>
            </template>
        </CModal>

    </div>
</template>
<script>
import FormModal from '@/views/catalogos/bancoImagenProducto/ProductosModal.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionProductoBancoImagen';
const EmitEjecuta2 = 'seccionProducto';
export default {
    name: 'FormProductoPresentacion',
    props: ['Id','Obj'],
    components:{FormModal},
    data() {
        return {
            ConfigList:{
                Title: 'Formulario de Productos',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: this.$limitCharacters(this.Obj.Descripcion,60),
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModal:{
                ModalTitle: "Asignar Producto",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
                ModalSize:'xl',
                // FullScreen: true,
                ShowFooter:false
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'BancoImagenProductos',
                EmitSeccion: EmitEjecuta,
                ShowBtnCancel:false
            },
            oBtnSaveModal: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                TxtBtnSave:'Asignar'
            },
            objBancoImagenProducto:{
                IdBancoImagenxProducto:0,
                IdProducto:0,
                IdBancoImagen:0,
                Cantidad:0,
                PrecioTotal:0,
                ProductosSeleccionados:[]
            },
            segurity: {},
			masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
            errorvalidacion2: [],
			Emit: EmitEjecuta,
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            // PROPIO
            ProductosSeleccionados:[],
            BancoImagenProductos:[]
        }
    },
    methods: {
        async Guardar(){
            this.oBtnSave.DisableBtn=true;
            this.oBtnSave.Toast=0;
            this.errorvalidacion=[];
            this.objBancoImagenProducto.ProductosSeleccionados=this.ProductosSeleccionados;
            await this.$http.post("bancoImagenProductos",this.objBancoImagenProducto
            ).then((res) => {
                this.EjecutaConExito(res);
            }).catch((err) => {
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn=false;

            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Regresar(){
            this.$router.push({name:'BancoImagenProductos',params:{pObjBancoImagen:this.objBancoImagenProducto}});
        },
        ListaProductoBancoImagenes(){
            this.$http.get("bancoImagenProductosSimple",{
                params:{
                    IdBancoImagen:this.objBancoImagenProducto.IdBancoImagen
                }
            }).then((res)=>{
                this.BancoImagenProductos=res.data.data;
            })
        },
        AbreModal(){
            this.bus.$emit('NewModal_'+this.ConfigModal.EmitSeccion,0,this.objBancoImagenProducto);
        },
        AniadirProducto(item){
            this.ProductosSeleccionados.push(item);
            this.bus.$emit('CloseModal_'+this.ConfigModal.EmitSeccion);
        },
        Calcular(item,index){
            let Total=(isNaN(item.Cantidad)) ? 0 : parseFloat(item.Costo*item.Cantidad).toFixed(2);
            this.ProductosSeleccionados[index].PrecioTotal=Total;
        },
        EliminarProducto(index){
            this.$swal(Configs.configEliminar).then((result)=>{
                if (result.value) {
                    let IndiceEliminar=this.ProductosSeleccionados.findIndex((element)=>element.IdProducto==index);
                    this.ProductosSeleccionados.splice(IndiceEliminar,1);
                }
            })
        }
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);

        this.bus.$off('SeleccionarProducto');
    },
    mounted() {
        this.oBtnSave.DisableBtn = false;
        // this.Limpiar();
        this.objBancoImagenProducto.IdBancoImagen=this.Obj.IdBancoImagen;
        this.objBancoImagenProducto.Descripcion=this.Obj.Descripcion;
        this.ListaProductoBancoImagenes();

        if(this.Id!='') 
        {
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {

            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('SeleccionarProducto',(item)=>{
            this.AniadirProducto(item);
        });

    },
}
</script>